import React from 'react';
import { IconProps } from '.';

const SvgSidebarClose = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <g fill={color}>
        <path d='M17.031 9.53 14.561 12l2.47 2.47-1.06 1.06L12.44 12l3.53-3.53 1.06 1.06Z' />
        <path
          fillRule='evenodd'
          d='M20 3a3 3 0 0 1 3 3v12l-.004.154a3 3 0 0 1-2.842 2.842L20 21H4l-.154-.004a3 3 0 0 1-2.842-2.842L1 18V6a3 3 0 0 1 3-3h16ZM8.5 19.5H20a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 20 4.5H8.5v15ZM4 4.5A1.5 1.5 0 0 0 2.5 6v12A1.5 1.5 0 0 0 4 19.5h3v-15H4Z'
          clipRule='evenodd'
        />
      </g>
    </svg>
  );
};

export default SvgSidebarClose;
